import React from 'react';

import { Badge, Dot } from './styled';

/**
 * As três cores de um estado: fundo, texto e o ponto.
 *
 * É a forma que os mapas de estilo do dashboard já usam — `STATUS_STYLE`,
 * `INVITE_STATUS_STYLE`, `RESULT_STYLE`, `SEVERITY_STYLE`, `CONNECTOR_STATUS_STYLE` —, então o
 * badge aceita o objeto direto, sem quem chama desmontá-lo em três props.
 */
export type StatusTone = {
  bg: string;
  fg: string;

  /** Sem ponto, o badge é só a pílula colorida. */
  dot?: string;
};

export type StatusBadgeProps = {
  tone: StatusTone;
  children: React.ReactNode;
};

/**
 * Pílula de estado com ponto (MV2-1706).
 *
 * Existe porque o par pílula + ponto estava redeclarado à mão em muitos lugares: `Dot` em dez
 * arquivos, `Badge` em seis, sempre com as mesmas seis linhas de CSS. Um ajuste de raio ou de
 * espaçamento exigia dezesseis edições, e bastava esquecer uma para a tela ficar desalinhada.
 *
 * Fica em atoms por ser o precedente do repo para marca de estado — `atoms/RiskScoreBadge`.
 */
const StatusBadge: React.FC<StatusBadgeProps> = ({ tone, children }) => (
  <Badge bg={tone.bg} fg={tone.fg}>
    {tone.dot && <Dot color={tone.dot} />}
    {children}
  </Badge>
);

export default StatusBadge;
